import { useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import Rating from '@mui/material/Rating';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';

const StyledRating = styled(Rating)(({ theme }) => ({
  '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
    color: theme.palette.action.disabled,
  },
}));

const customIcons = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon fontSize="large" color="error" />,
    label: 'Very Dissatisfied',
  },
  2: {
    icon: <SentimentDissatisfiedIcon fontSize="large" color="error" />,
    label: 'Dissatisfied',
  },
  3: {
    icon: <SentimentSatisfiedIcon fontSize="large" color="warning" />,
    label: 'Neutral',
  },
  4: {
    icon: <SentimentSatisfiedAltIcon fontSize="large" color="success" />,
    label: 'Satisfied',
  },
  5: {
    icon: <SentimentVerySatisfiedIcon fontSize="large" color="success" />,
    label: 'Very Satisfied',
  },
};

function IconContainer(props) {
  const { value, ...other } = props;
  return <span {...other}>{customIcons[value].icon}</span>;
}

const EmojiRating = (props) => {
  const { id, name, type, typeName, order, options, required, input: { onChange } } = props;

  const [rating, setRating] = useState(0);

  useEffect(() => {
    if (options?.length > 0) {
      for (let i = 0; i < options.length; i++) {
        if (options[i].default) {
          changeHandler(options[i]?.value);
        }
      }
    }
  }, []);

  const changeHandler = (newRating) => {
    if (!required && newRating === rating) {
      newRating = null;
    }
    setRating(newRating);

    if (!newRating) {
      return onChange(null);
    }
    return onChange(
      {
        id,
        typeName,
        order,
        result: newRating
      }
    );
  }

  return (
    <StyledRating
      name="highlight-selected-only"
      value={rating}
      // defaultValue={rating}
      IconContainerComponent={IconContainer}
      getLabelText={(value) => customIcons[value].label}
      highlightSelectedOnly
      onChange={(event, newValue) => {
        changeHandler(newValue);
      }}
    />
  );

};

export default EmojiRating;